import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

interface IProps {
  metas: any;
  title: string;
  lang: string;
}

const SEO = ({ metas, title, lang }: IProps) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  );

  const defaultTitle = site.siteMetadata?.title
  const metaInfo = [];

  if (metas.length) {
    metas.map(meta => {
      const value = Object.fromEntries(Object.entries(meta.attributes).filter(([_, v]) => v != null));
      metaInfo.push(value)
    });
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={metaInfo}
      link={metaInfo}
    />
  );
};

export default SEO;
